// src/modules/inventory/pages/InventoryAddPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import InventoryForm from "../components/InventoryForm";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import api from "../../../services/api";

const InventoryAddPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (data: any) => {
    try {
      await api.post("/inventory", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate("/inventory");
    } catch (err: any) {
      alert(err.response?.data?.message || "Could not add item.");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-8">
      <h1 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">Add Inventory Item</h1>
      <InventoryForm onSubmit={handleSubmit} />
    </div>
  );
};

export default InventoryAddPage;
